import api from '@/client/core/api'
import {
  IssueInstagramInstantwinPretestEntryCodeRequest,
  parseIssueInstagramInstantwinPretestEntryCodeRequest
} from '@/typings/api/instagram_instantwin_pretest_entry_codes.schema'

type PostInstagramInstantwinPretestEntryCodeApiResponse = {
  data?: boolean
  error?: {
    type?: string
    message?: string
    status?: number
  }
}

export class PostInstagramInstantwinPretestEntryCodeApiError extends Error {
  constructor(
    public type: string,
    message?: string,
    public status?: number
  ) {
    super(message || type)
  }
}

export type PostInstagramInstantwinPretestEntryCodeParams = IssueInstagramInstantwinPretestEntryCodeRequest & {
  prizeId: number
}

export async function postInstagramInstantwinPretestEntryCode(
  params: PostInstagramInstantwinPretestEntryCodeParams
): Promise<void> {
  const request = parseIssueInstagramInstantwinPretestEntryCodeRequest({
    lotteryResult: params.lotteryResult,
    expirationMinutes: params.expirationMinutes
  })

  const response = await api.post<PostInstagramInstantwinPretestEntryCodeApiResponse>(
    `/instagram_instantwin_prizes/${params.prizeId}/pretest_entry_code`,
    request
  )

  if (response instanceof Error) {
    throw response
  }

  if (response?.error?.type) {
    throw new PostInstagramInstantwinPretestEntryCodeApiError(
      response.error.type,
      response.error.message,
      response.error.status
    )
  }

  return undefined
}
